<template>
  <v-radio-group
    v-model="selectedAnswerReductionType"
    hide-details
    row
    class="my-6">
    <v-radio
      v-for="(option, index) in options"
      :key="index"
      :label="option.text"
      :value="option.value"
      color="secondary"
    ></v-radio>
  </v-radio-group>
</template>

<script>
export default {
  data: () => ({
    options: [
      {text: '１枚で縮小をかける', value: '1'},
      {text: '両面印刷で縮小をかけない', value: '2'},
    ],
  }),

  computed: {
    selectedAnswerReductionType: {
      get() {
        return this.$store.state.sheet.answerReductionType;
      },
      set(value) {
        this.$store.commit('sheet/setAnswerReductionType', { answerReductionType: value })
      }
    },
  },

  methods: {
    async createAnswerSeet(){
      this.$app.$refs.loading.open({type: 'print', message: 'プレビュー作成中'})
      this.$store.commit('sheet/setIsUpdate', {type: 'answerSheet', isUpdate: true})
      await this.$store.dispatch('sheet/getSheetImages', {params:{type:'answerSheet'}})
      this.$app.$refs.loading.close({})
    }
  },

  watch: {
    selectedAnswerReductionType(now, old) {
      if (now && old) this.createAnswerSeet()
    }
  }
}
</script>
